'use client';

import { HeaderLogo } from './HeaderLogo';
import { NavLinks } from './NavLinks/NavLinks';
import { DarkModeToggle } from './DarkModeToggle';

export interface MainLayoutProps {
    children: React.ReactNode;
    rightContent?: React.ReactNode;
    showLessons: boolean;
    showProjects: boolean;
}

export const MainLayout = ({
    children,
    rightContent,
    showLessons,
    showProjects,
}: MainLayoutProps) => (
    <div className="flex h-screen w-screen flex-col overflow-x-hidden bg-zinc-50 dark:bg-slate-950">
        <header className="navbar h-12 border-b border-slate-400 px-6 tall:h-20 dark:border-gray-700">
            <HeaderLogo />
            <div className="hidden md:flex">
                <NavLinks
                    showLessons={showLessons}
                    showProjects={showProjects}
                />
            </div>
            <div className="navbar-end flex justify-end gap-4 lg:gap-6">
                {rightContent}
                <DarkModeToggle />
            </div>
        </header>
        <div className="flex justify-center pt-1 md:hidden">
            <NavLinks showLessons={showLessons} showProjects={showProjects} />
        </div>
        {children}
    </div>
);
